import { render, staticRenderFns } from "./transportation-list.vue?vue&type=template&id=1219aa80&"
import script from "./transportation-list.vue?vue&type=script&lang=js&"
export * from "./transportation-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports